module.exports = __webpack_public_path__ + "img/1.89bdc059.png";